/* Product Filter */

jQuery(document).ready(function($) {

	$(".c-cat-drop").on("click", function() {
		$(this).closest("li").toggleClass("active");
	});

});
